export class HistRxReferralConst {
  static readonly RxStdCode_轉診034B: string = '01034B'; 
  static readonly RxStdCode_轉診035B: string = '01035B'; 
  static readonly RxStdCode_轉診036C: string = '01036C';
  static readonly RxStdCode_轉診037C: string = '01037C'; 
  static readonly RxStdCode_轉診038C: string = '01038C'; 
  static readonly RxStdCode_轉診193C: string = '00193C'; 

  static readonly Rx轉診大集合: string[] = [
    HistRxReferralConst.RxStdCode_轉診034B,
    HistRxReferralConst.RxStdCode_轉診035B,
    HistRxReferralConst.RxStdCode_轉診036C,
    HistRxReferralConst.RxStdCode_轉診037C,
    HistRxReferralConst.RxStdCode_轉診038C,
    HistRxReferralConst.RxStdCode_轉診193C,

  ];
}



/** 指定調劑方式的醫令對照
 *  以 StdCode 完全相符比對，dispTP 為該醫令允許的調劑方式(OrderDispensingTypeEnum 值)白名單。
 *  同一個 stdCode 只列一筆，多個合法值合併進同一筆的 dispTP；對照表為空時整條檢查不作用。
 *  消費端：order-grid 完診驗證 checkDispTPByStdCode()，僅提示不改值。
 */
export class HistRxDispRuleConst {
  static readonly Rx指定調劑對照: { stdCode: string; dispTP: string[] }[] = [
    { stdCode: 'XCOVID0002', dispTP: ['0'] },
    { stdCode: 'XCOVID0004', dispTP: ['0'] },
  ];

  static find(stdCode: string): { stdCode: string; dispTP: string[] } | null {
    if (!stdCode) return null;
    return this.Rx指定調劑對照.find(x => x.stdCode === stdCode) ?? null;
  }
}


/** 交付調劑處方箋須單獨成張的醫令
 *  以 StdCode 完全相符比對；命中者自所屬清單抽出，於處方箋尾端另成一張輸出。
 *  僅非慢箋病歷適用；慢箋(含 /7 切分)不做此處理。
 *  抽出後清單會變空時不抽——整張本來就只有該醫令，不需再切。
 *  消費端：repeated-prescription / repeated-pres-dynamic 兩個報表元件。
 */
export class HistRxDispPresConst {
  static readonly Rx單獨列印: string[] = ['XCOVID0001'];

  static is單獨列印(stdCode: string): boolean {
    return !!stdCode && this.Rx單獨列印.includes(stdCode);
  }
}


export class HistRxCataractConst {
  static readonly RxStdCode_手術_86006C: string = '86006C'; 
  static readonly RxStdCode_手術_86007C: string = '86007C'; 
  static readonly RxStdCode_手術_86008C: string = '86008C';
  static readonly RxStdCode_手術_86011C: string = '86011C'; 
  static readonly RxStdCode_手術_86012C: string = '86012C'; 

 static readonly RxStdCode_手術_97605K: string = '97605K'; 
  static readonly RxStdCode_手術_97606A: string = '97606A'; 
  static readonly RxStdCode_手術_97607B: string = '97607B';
  static readonly RxStdCode_手術_97608C: string = '97608C'; 
 		static readonly RxStdCode_麻醉_96009C: string = '96009C'; 
  static readonly RxStdCode_麻醉_96017C: string = '96017C'; 
  static readonly RxStdCode_麻醉_96020C: string = '96020C';
  static readonly RxStdCode_麻醉_96000C: string = '96000C'; 



  static readonly Rx手術麻醉大集合: string[] = [
    HistRxCataractConst.RxStdCode_手術_86006C,
    HistRxCataractConst.RxStdCode_手術_86007C,
    HistRxCataractConst.RxStdCode_手術_86008C,
    HistRxCataractConst.RxStdCode_手術_86011C,
    HistRxCataractConst.RxStdCode_手術_86012C,
    HistRxCataractConst.RxStdCode_麻醉_96009C,
   HistRxCataractConst.RxStdCode_麻醉_96017C ,
   HistRxCataractConst.RxStdCode_麻醉_96020C,
   HistRxCataractConst.RxStdCode_麻醉_96000C 
  
  ];
  static is白內障手術或麻醉(code: string): boolean { 
    return this.Rx手術麻醉大集合.includes(code);
  }
}
